export default {
  // Tab names
  'tab.main': 'Principal',
  'tab.producers': 'Productores',
  'tab.achievements': 'Logros',
  'tab.prestige': 'Prestigio',
  'tab.settings': 'Ajustes',

  // Header
  'header.bps': '/seg',
  'header.stage': 'Etapa',
  'header.tap': 'TAP!',

  // Combo
  'combo.nice': 'Nice!',
  'combo.great': 'Great!',
  'combo.amazing': 'Amazing!',
  'combo.incredible': 'INCREDIBLE!',
  'combo.legendary': 'LEGENDARY!',
  'combo.label': 'Combo',

  // Critical
  'crit.label': 'CRITICAL!',

  // Producers
  'producer.P1': 'Semilla',
  'producer.P2': 'Brote',
  'producer.P3': 'Plantita',
  'producer.P4': 'Cafeto',
  'producer.P5': 'Finca Peq.',
  'producer.P6': 'Finca Grande',
  'producer.P7': 'Tostadero',
  'producer.P8': 'Fabrica de Cafe',
  'producer.P9': 'Centro de Export.',
  'producer.P10': 'Franquicia',
  'producer.P11': 'Imperio del Cafe',
  'producer.P12': 'Planeta Cafe',

  // Tap upgrades
  'upgrade.T1': 'Dedos Rapidos',
  'upgrade.T2': 'Guantes',
  'upgrade.T3': 'Herramientas',
  'upgrade.T4': 'Maquinaria',
  'upgrade.T5': 'Robot',
  'upgrade.T6': 'Nanotecnologia',
  'upgrade.T7': 'Cosecha Cuantica',
  'upgrade.T8': 'Distorsion Temporal',

  // Prestige upgrades
  'prestige.G1': 'Semilla Dorada',
  'prestige.G1.desc': 'BPS +1 base',
  'prestige.G2': 'Tierra Fertil',
  'prestige.G2.desc': 'Poder de toque x1.5',
  'prestige.G3': 'Descuento Inicial',
  'prestige.G3.desc': 'P1~P3 costo -50%',
  'prestige.G4': 'Crecimiento Nocturno',
  'prestige.G4.desc': 'Eficiencia offline +20%',
  'prestige.G5': 'Cultivo Rapido',
  'prestige.G5.desc': 'BPS total x2',
  'prestige.G6': 'Manos de Suerte',
  'prestige.G6.desc': 'Prob. critico +3%',
  'prestige.G7': 'Barista Maestro',
  'prestige.G7.desc': 'Poder de toque x3',
  'prestige.G8': 'Descuento Mayorista',
  'prestige.G8.desc': 'Todos los costos -20%',
  'prestige.G9': 'Inicio Rapido',
  'prestige.G9.desc': 'Empezar con 10 P1~P3',
  'prestige.G10': 'Mezcla Premium',
  'prestige.G10.desc': 'BPS total x3',
  'prestige.G11': 'Grano del Tiempo',
  'prestige.G11.desc': 'Eficiencia offline 100%',
  'prestige.G12': 'Corona del Rey Cafe',
  'prestige.G12.desc': 'Produccion total x2',
  'prestige.G13': 'Arbol de Granos Dorados',
  'prestige.G13.desc': 'Ganancia de granos dorados +20%',
  'prestige.G14': 'Viaje en el Tiempo',
  'prestige.G14.desc': 'Empezar en etapa 5',
  'prestige.G15': 'Granos Infinitos',
  'prestige.G15.desc': 'Produccion total x10',
  'prestige.G16': 'Big Bang Cafetero',
  'prestige.G16.desc': 'Ganancia de granos dorados x2',

  // Star upgrades
  'star.S1': 'Fondo Inicial',
  'star.S1.desc': '1M de granos al inicio',
  'star.S2': 'Oro Eterno',
  'star.S2.desc': 'Granos dorados x2 permanente',
  'star.S3': 'Bendicion Estelar',
  'star.S3.desc': 'BPS total x5 permanente',
  'star.S4': 'Auto Toque',
  'star.S4.desc': '1 toque auto por segundo',
  'star.S5': 'Maestro del Combo',
  'star.S5.desc': 'Duracion del combo 3 seg',
  'star.S6': 'Golpe Mortal',
  'star.S6.desc': 'Multiplicador critico x2',
  'star.S7': 'Poder Cosmico',
  'star.S7.desc': 'Produccion total x10 permanente',
  'star.S8': 'Estrella Trascendental',
  'star.S8.desc': 'Bonus de ascension x3',

  // Varieties
  'variety.V1': 'Arabica',
  'variety.V2': 'Robusta',
  'variety.V3': 'Liberica',
  'variety.V4': 'Excelsa',
  'variety.V5': 'Geisha',
  'variety.V6': 'Kopi Luwak',
  'variety.V7': 'Blue Mountain',
  'variety.V8': 'Kona',
  'variety.V9': 'Yirgacheffe',
  'variety.V10': 'Peaberry',
  'variety.V11': 'Maragogipe',
  'variety.V12': 'St. Helena',

  // Stages
  'stage.1': 'Jardin de la Abuela',
  'stage.2': 'Patio Pequeno',
  'stage.3': 'Finca de Cafe',
  'stage.4': 'Tostadero',
  'stage.5': 'Fabrica de Cafe',
  'stage.6': 'Cadena Global',
  'stage.7': 'Reino del Cafe',

  // Roasting
  'roast.perfect': 'Tueste Perfecto!',
  'roast.dark': 'Tueste Oscuro',
  'roast.medium': 'Tueste Medio',
  'roast.light': 'Tueste Claro',
  'roast.burnt': 'Quemado...',
  'roast.raw': 'Crudo',
  'roast.tap': 'Toca para detener!',
  'roast.reward': 'Recompensa',
  'roast.double': 'Ver anuncio para 2x!',
  'roast.collect': 'Recoger',

  // Achievements
  'ach.tap1': 'Primeros Pasos', 'ach.tap1.desc': '100 toques',
  'ach.tap2': 'Manos Ocupadas', 'ach.tap2.desc': '1,000 toques',
  'ach.tap3': 'Maestro del Toque', 'ach.tap3.desc': '10,000 toques',
  'ach.tap4': 'Dedo Legendario', 'ach.tap4.desc': '100,000 toques',
  'ach.tap5': 'Dios del Toque', 'ach.tap5.desc': '1,000,000 toques',
  'ach.tap6': 'Manos Rapidas', 'ach.tap6.desc': '5 toques por segundo',
  'ach.tap7': 'Manos Relampago', 'ach.tap7.desc': '10 toques por segundo',
  'ach.tap8': 'Manos Divinas', 'ach.tap8.desc': '15 toques por segundo',
  'ach.tap9': 'Maniaco del Combo', 'ach.tap9.desc': 'Alcanzar 20 combo',
  'ach.tap10': 'Combo Legendario', 'ach.tap10.desc': 'Alcanzar 50 combo',

  'ach.prod1': 'Primera Cosecha', 'ach.prod1.desc': 'Cosechar 1K granos',
  'ach.prod2': 'Pequeno Logro', 'ach.prod2.desc': 'Cosechar 100K granos',
  'ach.prod3': 'Finca en Crecimiento', 'ach.prod3.desc': 'Cosechar 10M granos',
  'ach.prod4': 'Magnate del Cafe', 'ach.prod4.desc': 'Cosechar 1B granos',
  'ach.prod5': 'Emperador del Cafe', 'ach.prod5.desc': 'Cosechar 1T granos',
  'ach.prod6': 'Inicio de Automatizacion', 'ach.prod6.desc': 'Alcanzar 100 BPS',
  'ach.prod7': 'Fabrica en Marcha', 'ach.prod7.desc': 'Alcanzar 10K BPS',
  'ach.prod8': 'Revolucion Industrial', 'ach.prod8.desc': 'Alcanzar 1M BPS',
  'ach.prod9': 'Produccion Global', 'ach.prod9.desc': 'Alcanzar 100M BPS',
  'ach.prod10': 'Produccion Cosmica', 'ach.prod10.desc': 'Alcanzar 10B BPS',

  'ach.bld1': 'Granjero Novato', 'ach.bld1.desc': 'Tener 1 de P1~P4',
  'ach.bld2': 'Granjero Intermedio', 'ach.bld2.desc': 'Tener 1 de P1~P8',
  'ach.bld3': 'Granjero Maestro', 'ach.bld3.desc': 'Tener todos los productores',
  'ach.bld4': 'Inversion Enfocada', 'ach.bld4.desc': 'Tener 10 de un tipo',
  'ach.bld5': 'Compra Masiva', 'ach.bld5.desc': 'Tener 25 de un tipo',
  'ach.bld6': 'Coleccionista', 'ach.bld6.desc': 'Tener 50 de un tipo',
  'ach.bld7': 'Monopolista', 'ach.bld7.desc': 'Tener 100 de un tipo',
  'ach.bld8': 'Expansion del Negocio', 'ach.bld8.desc': '100 productores totales',
  'ach.bld9': 'Imperio Corporativo', 'ach.bld9.desc': '500 productores totales',
  'ach.bld10': 'Dominacion Mundial', 'ach.bld10.desc': '1000 productores totales',

  'ach.pres1': 'Primer Renacimiento', 'ach.pres1.desc': '1 prestigio',
  'ach.pres2': 'Sabor de Repeticion', 'ach.pres2.desc': '3 prestigios',
  'ach.pres3': 'Maestro del Prestigio', 'ach.pres3.desc': '5 prestigios',
  'ach.pres4': 'Ciclo Sin Fin', 'ach.pres4.desc': '10 prestigios',
  'ach.pres5': 'Anillo Eterno', 'ach.pres5.desc': '20 prestigios',
  'ach.pres6': 'Experto en Reencarnacion', 'ach.pres6.desc': '50 prestigios',
  'ach.pres7': 'Cosecha Dorada', 'ach.pres7.desc': '10 granos dorados de una vez',
  'ach.pres8': 'Tormenta Dorada', 'ach.pres8.desc': '100 granos dorados de una vez',
  'ach.pres9': 'Speedrunner', 'ach.pres9.desc': 'Prestigio en 30 min',
  'ach.pres10': 'Renacimiento Relampago', 'ach.pres10.desc': 'Prestigio en 15 min',

  'ach.spec1': 'Cazador de Cerezas', 'ach.spec1.desc': 'Tocar cereza dorada 1 vez',
  'ach.spec2': 'Maniaco de Cerezas', 'ach.spec2.desc': 'Tocar cereza dorada 10 veces',
  'ach.spec3': 'Maestro de Cerezas', 'ach.spec3.desc': 'Tocar cereza dorada 50 veces',
  'ach.spec4': 'Tueste Principiante', 'ach.spec4.desc': 'Tueste perfecto 1 vez',
  'ach.spec5': 'Tueste Experto', 'ach.spec5.desc': 'Tueste perfecto 10 veces',
  'ach.spec6': 'Coleccionista de Variedades', 'ach.spec6.desc': 'Recolectar 5 variedades',
  'ach.spec7': 'Doctor en Cafe', 'ach.spec7.desc': 'Recolectar las 12 variedades',
  'ach.spec8': 'Granjero Constante', 'ach.spec8.desc': '1 hora de juego total',
  'ach.spec9': 'Adicto al Cafe', 'ach.spec9.desc': '24 horas de juego total',
  'ach.spec10': '7 Dias Seguidos', 'ach.spec10.desc': '7 dias consecutivos',

  'ach.mile1': 'Caficultor', 'ach.mile1.desc': 'Alcanzar etapa 3',
  'ach.mile2': 'Empresario Cafetero', 'ach.mile2.desc': 'Alcanzar etapa 5',
  'ach.mile3': 'Rey del Cafe', 'ach.mile3.desc': 'Alcanzar etapa 7',
  'ach.mile4': 'Trascendente', 'ach.mile4.desc': 'Primera ascension estelar',
  'ach.mile5': 'Perfeccionista', 'ach.mile5.desc': 'Desbloquear 50 logros',

  // Achievement categories
  'ach.cat.tapping': 'Toques',
  'ach.cat.production': 'Produccion',
  'ach.cat.producers': 'Productores',
  'ach.cat.prestige': 'Prestigio',
  'ach.cat.special': 'Especial',
  'ach.cat.milestone': 'Hitos',

  // Prestige panel
  'prestige.title': 'Renacimiento del Tueste',
  'prestige.desc': 'Renace para ganar granos dorados y ser mas fuerte!',
  'prestige.goldenBeans': 'Granos Dorados',
  'prestige.expected': 'Ganancia Esperada',
  'prestige.rebirth': 'Renacer',
  'prestige.upgrades': 'Mejoras de Prestigio',
  'prestige.locked': 'Se desbloquea en etapa 7',
  'prestige.adBonus': 'Ver anuncio +30%',

  // Ascension panel
  'ascend.title': 'Ascension Estelar',
  'ascend.desc': 'Asciende para ganar polvo estelar y trascender todo!',
  'ascend.starDust': 'Polvo Estelar',
  'ascend.expected': 'Ganancia Esperada',
  'ascend.ascend': 'Ascender',
  'ascend.upgrades': 'Mejoras Estelares',
  'ascend.locked': 'Requiere 10 renacimientos + 100 granos dorados',

  // Settings
  'settings.bgm': 'Musica de Fondo',
  'settings.sfx': 'Efectos de Sonido',
  'settings.vibration': 'Vibracion',
  'settings.language': 'Idioma',
  'settings.reset': 'Borrar Datos',
  'settings.resetConfirm': 'Seguro que quieres borrar todos los datos?',
  'settings.credits': 'Creditos',
  'settings.version': 'Version',

  // Boost buttons
  'boost.tap': 'Impulso de Toque',
  'boost.bps': 'Impulso de Produccion',

  // Offline
  'offline.title': 'Bienvenido de vuelta!',
  'offline.earned': 'Ganancias Offline',
  'offline.time': 'Tiempo Fuera',
  'offline.collect': 'Recoger',
  'offline.adX3': 'Ver anuncio x3',

  // General
  'buy': 'Comprar',
  'max': 'Max',
  'level': 'Nv.',
  'locked': 'Bloqueado',
  'owned': 'Poseido',
  'on': 'ON',
  'off': 'OFF',
} as const;
